import { Loader } from 'components/common/loader'
import Router from 'next/router'
import React, { useEffect, useState } from 'react'

// eslint-disable-next-line
export const withLoader = (WrapperComponent: any) => {
  // eslint-disable-next-line
  const WithLoader = (props: any) => {
    const [isLoading, setIsLoading] = useState(true)

    const handleLoading = () => {
      setIsLoading(false)
    }

    // Router.events.on('routeChangeStart', () => setIsLoading(true))
    Router.events.on('routeChangeComplete', () => setIsLoading(false))
    Router.events.on('routeChangeError', () => setIsLoading(false))

    useEffect(() => {
      // window.addEventListener('load', handleLoading)
      setTimeout(() => {
        setIsLoading(false)
      }, 2 * 1000)
      return () => window.removeEventListener('load', handleLoading)
    }, [])

    return !isLoading ? (
      <WrapperComponent {...props} />
    ) : (
      <>
        <Loader />
        <WrapperComponent {...props} />
      </>
    )
  }
  return WithLoader
}

export default withLoader
